import React from 'react'

export const DefaultHeader: React.FC = props => {
    return <div className='flex justify-center items-center'>{props.children}</div>
}
